<template>
  <v-app>
       <transition name="slide-fade">
          <router-view></router-view>
       </transition>
        
          
          <v-progress-linear
            v-if="load"
            class="determinacion-loading"
            indeterminate
            color="primary"
            height="3"
          ></v-progress-linear>
        
             
        
  </v-app>
</template>

<script>
export default {
     data(){
       return {

       }
     },

     computed: {
       load(){
         return this.$store.state.loading_charge
       }
     },
}
</script>
<style>
  
  .determinacion-loading{

    position: fixed;
    bottom: 0;


  }

</style>